import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onMounted, reactive, ref } from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CModal from '../CModal.vue';
import CButton from '@/components/shared/CButton';
import CBadge from '@/components/shared/CBadge/CBadge.vue';
import CInput from '@/components/shared/CInput.vue';
import CTextarea from '@/components/shared/CTextarea.vue';
import CEmptyState from '@/components/shared/CEmptyState.vue';

interface VariantOption {
    name: string;
    values: Record<'name' | 'hint', string>[];
    isPrintSizeVariant?: boolean;
    isColorOptionVariant?: boolean;
    readOnlyValues?: boolean;
}

interface ProductData {
    variants: VariantOption[];
    printSizeVariant?: VariantOption;
    description?: string;
    partialSave?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateProductVariantsModal',
  props: {
    variants: null,
    displayDescription: { type: Boolean, default: true },
    canAddPrintSize: { type: Boolean, default: true },
    canAddVariantOptions: { type: Boolean }
  },
  emits: ["save-product", "close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'save-product', data: ProductData): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { variants: VariantOption[], displayDescription: boolean, canAddPrintSize: boolean, canAddVariantOptions?: boolean };





const model = reactive({
    description: '',
    variantOptions: [] as VariantOption[]
});

const variantFormRef = ref<InstanceType<typeof ValidationObserver> | null>(null);
const isValidForm = () => variantFormRef.value?.validate();

const selectedVariant = ref<number | undefined>();
const editVariantOption = async (optionIdx?: number) => {
    if (!(await isValidForm())) return;

    selectedVariant.value = optionIdx;
};

const displayAddOptionBtn = computed(
    () => props.canAddVariantOptions && model.variantOptions.filter((o) => !o.isPrintSizeVariant).length < 2
);
const addVariantOption = async () => {
    if (!(await isValidForm())) return;

    model.variantOptions.push({
        name: '',
        values: [{ name: '', hint: '' }]
    });
    editVariantOption(model.variantOptions.length - 1);
};

const saveVariantOption = async () => {
    if (!(await isValidForm())) return false;
    editVariantOption();
};

const deleteVariantOption = (index: number) => {
    model.variantOptions.splice(index, 1);
    editVariantOption();
};

const onVariantValueChange = async (
    val: string | number,
    optionValue: Record<'name' | 'hint', string>,
    option: VariantOption
) => {
    const values = String(val).split(',');
    optionValue.name = values.shift() || '';

    if (!values.length) return;
    await addVariantValue(option, values);
};

const addVariantValue = async (option: VariantOption, optionValues?: string[]) => {
    if (option.isPrintSizeVariant || option.readOnlyValues) return;

    const values = (optionValues || ['']).map((val) => ({ name: val, hint: '' }));
    option.values.push(...values);

    await nextTick();
    const newInput = document.getElementById(
        `${option.name}-option-value-${option.values.length - 1}`
    ) as HTMLInputElement;
    newInput?.focus();
};

const deleteVariantValue = (option: VariantOption, index: number) => {
    option.values.splice(index, 1);
};

const saveProduct = async (partial = false) => {
    const valid = await saveVariantOption();
    if (valid === false) return;

    emit('save-product', {
        variants: model.variantOptions,
        description: model.description,
        partialSave: partial
    });
};

onMounted(() => {
    model.variantOptions = [...props.variants];
});

return { __sfc: true,props, emit, model, variantFormRef, isValidForm, selectedVariant, editVariantOption, displayAddOptionBtn, addVariantOption, saveVariantOption, deleteVariantOption, onVariantValueChange, addVariantValue, deleteVariantValue, saveProduct, ValidationProvider, ValidationObserver, CModal, CButton, CBadge, CInput, CTextarea, CEmptyState }
}

})